<template>
  <v-data-table
    :headers="tblHeaders"
    :items="value"
    disable-pagination
    hide-default-footer
  >
    <template v-slot:[`item.all`]="{item}">
      <room-selector 
        :value="item.value[0]"
        :suffix="item.suffix"
        @activated="deActivateRooms(item)"
      ></room-selector>
    </template>
    <template v-slot:[`item.rooms`]="{item}">
      <room-selector
        v-for="room of item.value.slice(1)"
        :key="room.name"
        :value="room"
        :suffix="item.suffix"
        @activated="deActivateObject(item)"
        @changed="updateObjectValue(item)"
      ></room-selector>
    </template>
  </v-data-table>
</template>

<script>
import RoomSelector from './ConstructorRoomSelector';

export default {
  name: 'layers-selector',

  components: {
    RoomSelector
  },

  props: {
    value: Array
  },

  data() {
    return {
      tblHeaders: [
        {
          text: 'Слой',
          value: 'name'
        },
        {
          text: 'Объем работ (всего)',
          value: 'all'
        },
        {
          text: 'Объем работ (по комнатам)',
          value: 'rooms'
        }
      ]
    }
  },

  methods: {
    deActivateRooms(item) {
      for (let room of item.value.slice(1)) {
        if (room.isActive) room.isActive = false;
      } 
    },
    deActivateObject(item) {
      if (item.value[0].isActive) item.value[0].isActive = false;
    },
    updateObjectValue(item) {
      if (!item.value[0].isActive) {
        item.value[0]._value = item.value.slice(1).reduce((sum, cur) => sum + Number(cur.value), 0).toFixed(2);
      }
    },
  }
}
</script>